export interface IValidationState {
    validationRules: Record<string, string>;
}

export const state: IValidationState = {
    validationRules: {}
};
